// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grade[data-v-3f2d0bb8] {\n  padding: 10px 20px;\n}\n.today[data-v-3f2d0bb8] {\n  height: 42px;\n  line-height: 42px;\n  background: #f6faff;\n  padding-left: 10px;\n}\n.drop[data-v-3f2d0bb8] {\n  width: 0 !important;\n}\n.el-col-8[data-v-3f2d0bb8] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 124px;\n}\n.el-col-8 p[data-v-3f2d0bb8] {\n  text-align: center;\n  font-size: 12px;\n  transform: scale(0.8);\n}", ""]);
// Exports
module.exports = exports;
